module.exports = __webpack_public_path__ + "img/upload-err2.ce75b009.png";